/**
 * Created by aaikepae on 1/27/17.
 */

import {browserHistory} from 'react-router';
import {getCookie, setCookie, setCiscoCookie} from './cookie';

export const QueryString = (function () {
    // This function is anonymous, is executed immediately and
    // the return value is assigned to QueryString!
    const query_string = {};
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        // If first entry with this name
        if (typeof query_string[pair[0]] === "undefined") {
            query_string[pair[0]] = decodeURIComponent(pair[1]);
            // If second entry with this name
        } else if (typeof query_string[pair[0]] === "string") {
            const arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
            query_string[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            query_string[pair[0]].push(decodeURIComponent(pair[1]));
        }
    }
    return query_string;
}());


export function getLanguage() {
    const language_in_cookie = getCookie("devnet_language");
    const language = navigator.language || navigator.userLanguage;
    return language_in_cookie || language && language.substr(0, 2) || "en";
}


export function setLanguage(value) {
    return setCiscoCookie("devnet_language", value);
}

export function openURL(url, e, action) {
    if (action instanceof Promise) {
        action.then(() => {
            _openURL(url, e);
        });
    } else if (typeof action === 'function') {
        const r = action();
        if (r !== false) {
            _openURL(url, e);
        }
    } else {
        _openURL(url, e);
    }

    e.preventDefault();
    return false;
}

function _openURL(url, e) {
    if (url.startsWith('/')) {
        browserHistory.push(url);
    } else {
        window.open(url);
    }
}

export function handleLoaderClick(url) {
    browserHistory.push(url);
    const history = ProfileUI && ProfileUI.getHistory();
    history && history.replace(url);
}

export function update_status_code(code = "200") {
    const el = document.querySelector("meta[name*='status_code']");
    if (el) {
        el.setAttribute("content", code + "");
    }
}